import React, { memo } from 'react';

import { useModalTeamProjectBody } from './useModalTeamProjectBody';
import { ModalBody } from '../../../../../components/newUI/Modal/ModalBody/ModalBody';
import { Roles } from '../../../../AddProject/types/types';
import { ProjectTeamRow } from '../components/ProjectTeamRow/ProjectTeamRow';
import cls from '../ModalTeamProject.module.css';

export const ModalTeamProjectBody = memo(() => {
    const {
        openedInviteCard,
        onOpenedInviteCardChange,
        onEmployersListSet,
        employersList,
        closingCard,
        onSetClosingCard,
    } = useModalTeamProjectBody();
    const roles = [Roles.MANAGER, Roles.FOREMAN, Roles.PURCHASER];

    return (
        <div className={cls.body}>
            {roles.map((role) => (
                <ProjectTeamRow
                    key={role}
                    closingCard={closingCard}
                    onSetClosingCard={onSetClosingCard}
                    onEmployersListSet={onEmployersListSet}
                    employersList={employersList}
                    onOpenedInviteCardChange={onOpenedInviteCardChange}
                    openedInviteCard={openedInviteCard}
                    role={role}
                />
            ))}
        </div>
    );
});
